(() => {
  const initialize = () => {
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), {threshold:.05});
    document.querySelectorAll('[data-story-reveal]:not(.story-reveal-ready)').forEach(section => {
      section.classList.add('story-reveal-ready'); observer.observe(section);
    });
  };
  initialize(); document.addEventListener('shopify:section:load', initialize);
})();
